import { Head, usePage, Link } from "@inertiajs/react";
import dayjs from "@/lib/dayjs";
import DefaultContainer from "@/components/default_container";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function Dashboard({ bookings }) {
  const { current_team, asset_types } = usePage().props;
  const assetType = asset_types[0];

  const now = dayjs();

  const bookingsWithStatus = bookings.map((booking) => {
    const start = dayjs(booking.starts_at);
    const end = dayjs(booking.ends_at);
    let status;
    if (start.isBefore(now) && end.isAfter(now)) {
      status = "in_progress";
    } else if (end.isBefore(now)) {
      status = "finished";
    } else {
      status = "upcoming";
    }
    return { ...booking, status };
  });

  return (
    <DefaultContainer>
      <Head title="Dashboard" />
      {assetType && (
        <div className="flex items-center justify-between rounded-md border p-6 mb-6">
          <span className="font-semibold">Book a Meeting Room</span>
          <Button asChild>
            <Link href={`/${current_team.slug}/asset_types/${assetType.id}/bookings/new`}>
              Quick Book
            </Link>
          </Button>
        </div>
      )}

      <div>
        <h2 className="font-semibold text-lg mb-3">My Bookings</h2>
        {bookingsWithStatus.length === 0 ? (
          <p className="text-muted-foreground text-sm">No bookings.</p>
        ) : (
          <ul className="flex flex-col gap-2">
            {bookingsWithStatus.map((booking) => (
              <li key={booking.id} className="flex items-center gap-4 rounded-md border px-4 py-3">
                <StatusBadge status={booking.status} />
                <span className="font-medium">{booking.asset.name}</span>
                <span className="text-sm text-muted-foreground">
                  {dayjs(booking.starts_at).tz(current_team.timezone).format("MMM D, YYYY")}
                </span>
                <span className="text-sm">
                  {dayjs(booking.starts_at).tz(current_team.timezone).format("HH:mm")} – {dayjs(booking.ends_at).tz(current_team.timezone).format("HH:mm")}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </DefaultContainer>
  );
}

function StatusBadge({ status }) {
  if (status === "in_progress") return <Badge>In Progress</Badge>;
  if (status === "finished")    return <Badge variant="secondary">Just Finished</Badge>;
  return <Badge variant="outline">Upcoming</Badge>;
}
